module.exports = __webpack_public_path__ + "static/img/banner.7f5685f7.jpg";